export type NewCustomerWizardStep = {
  step: number;
  title: string;
  percent: number;
};

export const NEW_CUSTOMER_WIZARD_STEPS: readonly NewCustomerWizardStep[] = [
  // Percent = work already finished, not "which step you're on".
  // Step 1 open → 0%; after step 1 (on step 2) → 25%; etc. Created → 100%.
  { step: 1, title: "Client Organization", percent: 0 },
  { step: 2, title: "Environment & Monitoring", percent: 25 },
  { step: 3, title: "Client User & Review", percent: 50 },
  { step: 4, title: "Customer Created", percent: 100 },
] as const;

export function getNewCustomerWizardStep(
  pathname: string,
): NewCustomerWizardStep | null {
  const stepMatch = pathname.match(/\/customers\/new\/step-(\d)/);
  if (stepMatch) {
    const stepNum = Number.parseInt(stepMatch[1]!, 10);
    return (
      NEW_CUSTOMER_WIZARD_STEPS.find((s) => s.step === stepNum) ?? null
    );
  }
  if (/^\/customers\/[^/]+\/created$/.test(pathname)) {
    return NEW_CUSTOMER_WIZARD_STEPS[3] ?? null;
  }
  return null;
}
